<div class="init">
    <div class="layout-content-wrapper">
        <section>
            <div class="container">
                <div class="card" *ngFor="let item of modules">
                    <div class="imgBx">
                        <img class="" [src]="item.imagen" alt="">
                        <h2>{{item.nombre}}</h2>
                    </div>
                    <div class="content">
                        <button (click)="coreBuscar(item.link)" label="Ingresar">Ingresar</button>
                    </div>
                </div> 
            </div>
        </section>
        <a (click)="coreSalir()" class="btn-flotante">Salir</a>
        <app-footer style="background: #232323;"></app-footer>
    </div>
</div>